<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${transaction.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="transaction" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "transaction-view-logs",

  components: { LogListTable },

  props: ["transaction"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
